﻿function encodeUrl(text: string): string {
    return encodeURI(text)
        .replace(new RegExp(':', 'g'), '%3A')
        .replace(new RegExp('=', 'g'), '%3D')
        .replace(new RegExp('/', 'g'), '%2F');
}

function decodeUrl(text: string): string {
    return decodeURI(text)
        .replace(new RegExp('%3A', 'gi'), ':')
        .replace(new RegExp('%3D', 'gi'), '=')
        .replace(new RegExp('%2F', 'gi'), '/')
        .replace(new RegExp('\\+', 'g'), ' ');
}

function lineBreakToTag(text: string): string {
    const regexp = new RegExp('(\n|\r|\r\n)', 'g');
    return text ? text.replace(regexp, '<br>') : '';
}

function tagToLineBreak(text: string): string {
    const regexp = new RegExp('(<br\s*/?>)', 'g');
    return text ? text.replace(regexp, '\r\n') : '';
}

function stripHtmlTags(input: string) {
    if (!input?.length) return input;
    input = input.replace('<br />', ', ');
    return input.replace(/<(?:.|\n)*?>/gm, '');
}

function removeTags(string: string): string {
    return string.replace(/<!--.*-->/g, '').replace(/¶/g, '');
}

function htmlEncode(string: string): string {
    return string
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/(?:^(?:&nbsp;)+)|(?:(?:&nbsp;)+$)/g, '');
}

function decode(encodedString: string): string {
    const parser = new DOMParser;
    const dom = parser.parseFromString(`<!doctype html><body>${encodedString}`, 'text/html');
    return dom.body.textContent ?? '';
}

function decodeString(string: string): string {
    const fakeString = '!"#%&_';
    string = string.replace(/<.?br.?\/>/g, fakeString);
    string = decode(string);
    while (string.includes('&amp') || string.includes('&lt') || string.includes('&gt') || string.includes('&quot') || string.includes('&nbsp'))
        string = decode(string);
    string = string.replace(new RegExp(fakeString, 'g'), '<br/>');
    return removeTags(string);
}

function getString(input: number) {
    return input < 10 ? `0${input}` : input.toString();
}

function removeHtml(str: string): string {
    return str.replace(/<[^>]*>?/gm, '');
}

/**
 * функция дописывает 0 слева от числа
 * */
function leftPad(number: number, targetLength: number): string {
    const isNegativeNumber = number < 0;
    let output = number.toString();
    if (isNegativeNumber) {
        output = output.replace('-', '');
    }

    while (output.length < targetLength) {
        output = `0${output}`;
    }

    return isNegativeNumber ? `-${output}` : output;
}

function formatNumber(number: number, length: number) {
    return number.toString().padStart(length, '0');
}

function padZero(str: string, length = 2) {
    const zeros = new Array(length).join('0');
    return (zeros + str).slice(-length);
}

function setTargetBlankForLinks() {
    this.value(this.value().replace(/<a/gi, '<a target="_blank"'));
}

function compressToBase64(str: string) {
    const deflatted = window.pako.deflate(str);
    return window.base64js.fromByteArray(deflatted);
}

function decompressFromBase64(str: string) {
    const bytesArray = window.base64js.toByteArray(str);
    return window.pako.inflate(bytesArray, { to: 'string' });
}

function convertToMinutes(inputValue: string) {
    let result: number | null = null;
    if (inputValue) {
        const [hours, minutes] = inputValue.split(':').map(Number);
        result = hours * 60 + minutes;
    }
    return result;
}

window.getString = getString;
window.formatNumber = formatNumber;
window.leftPad = leftPad;
window.removeHtml = removeHtml;
window.decode = decode;
window.decompressFromBase64 = decompressFromBase64;
window.compressToBase64 = compressToBase64;
window.decodeUrl = decodeUrl;
window.encodeUrl = encodeUrl;
window.htmlEncode = htmlEncode;
window.convertToMinutes = convertToMinutes;
window.padZero = padZero;
window.decodeString = decodeString;
window.removeTags = removeTags;
window.lineBreakToTag = lineBreakToTag;
window.setTargetBlankForLinks = setTargetBlankForLinks;
window.stripHtmlTags = stripHtmlTags;
window.tagToLineBreak = tagToLineBreak;